

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import '@/styles/rootTheme.less'

Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js